module.exports = __webpack_public_path__ + "media/images/sp/brands/common/logo_suns-ab185661c59f263e744e709dddfb33bb.svg";